import styled, { css } from 'styled-components/macro';

export const Divider = styled.hr<{
  margin?: string;
  dividerStyles?: string;
  width?: string;
  borderColor?: string;
}>`
  margin: ${({ theme, margin }) =>
    margin ? margin : `${theme.spacing.one} 0 ${theme.spacing.one_2}`};

  border-top: 0;
  border-bottom: 1px solid
    ${({ borderColor, theme }) => (borderColor ? borderColor : theme.colors.black_20)};

  ${({ width }) =>
    width &&
    `
      width: ${width};
    `}

  ${({ dividerStyles }) =>
    dividerStyles === 'details-accordion' &&
    css`
      margin: ${({ theme }) => theme.spacing.zero_2} 0 ${({ theme }) => theme.spacing.one} -${({ theme }) => theme.spacing.one};
      width: calc(100% + 2rem);
    `}
`;
